<template>
	<div class="brick">
		<div v-if="float_panel.visible" class="sc-float-panel" :style="{ left: float_panel.x + 'px', top: float_panel.y + 'px' }">
			<div class="sc-float-header" @mousedown="startDragPanel">
				<span>Attached Document</span>
				<a href="javascript:void(0);" class="sc-float-close" @click="closePanel" @mousedown.stop>X</a>
			</div>
			<div class="sc-float-body">
				<img :src="float_panel.src" alt="File Not Found" />
			</div>
		</div>
		<div class="view_inner">
			<div class="divide_tbl">
				<table class="view_tbl" border="0">
					<colgroup>
						<col style="width:130px;" />
						<!-- <col style="width:400px;" /> -->
						<col style="" />
					</colgroup>
					<tbody>
						<tr>
							<th>Store Credit No</th>
							<td><input type="text" v-model="store_credit.sc_dn" class="tbl_int ssm2_int " readonly /></td>
						</tr>
						<tr>
							<th>Partner</th>
							<td>
								<div style="float:left;">
									<PartnerSelect v-model="store_credit.partner_code" :initialName="store_credit.partner_name" ph="Code" @set-partner="setPartner" />
								</div>
							</td>
						</tr>
						<tr>
							<th>Status</th>
							<td v-if="mode == 'detail'">
								<!-- {{ store_credit.status_code == 'R' ? 'Request' : store_credit.status_code == 'C' ? 'Confirmed' : 'Used' }} -->
								{{ store_credit.status_code | scStatusName }}
							</td>
						</tr>
						<tr>
							<th>Sales Person</th>
							<td>
								<CodeSelect className="tbl_select" :codes="salesGroups" v-model="store_credit.sales_group_code" />
							</td>
						</tr>

						<tr>
							<th>A/R Credit Type</th>
							<td>
								<CodeSelect className="tbl_select" :codes="arCreditTypeList" v-model="store_credit.ar_credit_type_code" />
							</td>
						</tr>

						<tr>
							<th>Entry User</th>
							<td>
								<input type="text" v-model.trim="store_credit.crt_user" class="tbl_int ssm2_int" readonly disabled />
								<template v-if="store_credit.upd_dt"> &nbsp;Last updated : {{ store_credit.upd_dt | moment('MM-DD-YYYY HH:mm:ss') }} by {{ store_credit.upd_user }} </template>
								<template v-else-if="store_credit.confirm_date">, &nbsp;Confirmed : {{ store_credit.confirm_date | moment('MM-DD-YYYY') }} by {{ store_credit.confirmer_id }} </template>
							</td>
						</tr>
						<tr v-if="user.company_id == 'beautyplus' || user.company_id == 'hairplus'">
							<th>Packer</th>
							<td>
								<span v-if="mode == 'detail'">{{ store_credit.packer_name }}. Change To</span>
								<select class="tbl_select quarter_int" v-model="store_credit.packer_id">
									<option :value="null"></option>
									<!-- <option v-for="(staff, index) in wh_staff_list" :key="index" :value="staff.barcode">{{ staff.barcode }} | {{ staff.name }} ({{ staff.user_id }})</option> -->
									<option v-for="(staff, index) in wh_staff_list" :key="index" :value="staff.user_id">{{ staff.name }} ({{ staff.user_id }})</option>
								</select>
							</td>
						</tr>
						<tr>
							<th>Credit($)</th>
							<td>
								<currency-input type="text" v-model.trim="store_credit.amount" :precision="2" class="tbl_int ssm2_int al_right" :disabled="store_credit.status_code == 'U'" />
								<span v-if="user.company_id == 'hairplus'">(-)</span>
							</td>
						</tr>
						<tr>
							<th>Invoice No</th>
							<td>
								<input type="text" v-model.trim="store_credit.linked_invoice_dn" class="tbl_int ssm2_int" readonly disabled />
								S/O No :
								<SoSelect
									v-model.trim="store_credit.so_dn"
									:initialFromDaysAgo="180"
									initialStatusCode="I"
									ph="Enter SO No or Scan Barcode"
									:initialShipToCode="store_credit.partner_code"
									:link="true"
									@set-invoice="setInvoiceFromList"
									@search="search()"
									:disabled="!store_credit.partner_code"
								/>
							</td>
						</tr>

						<tr v-if="isJc && store_credit.linked_invoice_no">
							<th>Invoice Items</th>
							<td>
								<table class="list_tbl">
									<thead>
										<tr>
											<th width="5%">#</th>
											<th width="20%">Item Code</th>
											<th>Name</th>
											<th width="12%">Qty</th>
											<th width="15%">Unit Price</th>
											<th width="15%">Amount</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(item, index) in invoice_item_list" :key="index">
											<td class="al_center">{{ index + 1 }}</td>
											<td class="al_left">{{ item.item_code }}</td>
											<td class="al_left">{{ item.name }}</td>
											<td class="al_right">{{ item.quantity }}</td>
											<td class="al_right">{{ item.unit_price | toCurrency }}</td>
											<td class="al_right">{{ item.amount | toCurrency }}</td>
										</tr>
										<tr v-if="!invoice_item_list.length">
											<td colspan="6" class="al_center">No items</td>
										</tr>
									</tbody>
								</table>
							</td>
						</tr>

						<tr>
							<th>Credit Info</th>
							<td>
								<textarea style="padding:2px;" rows="30" v-model.trim="store_credit.info" class="textarea_type"></textarea>
							</td>
						</tr>
						<tr>
							<td colspan="2">
								<table>
									<tr>
										<td v-for="(file, index) in org_image_files" :key="index + 'org'" style="width: 180px; position: relative;">
											<a v-if="modifiable" href="javascript: void(0);" @click="deleteOrgImage(file)" style="position: absolute; top: 0px; right: 10px;">X</a>
											<img v-img :src="getImageUrl(file)" class="mgr_15" alt="File Not Found" style="cursor: zoom-in;max-height:130px;max-width:170px;height:auto;width:auto;" />
											<a href="javascript:void(0);" @click="openImagePanel(file)" style="display:block;text-align:center;font-size:12px;">Open in panel</a>
										</td>
										<td v-for="(file, index) in new_image_files" :key="index + 'new'" style="width: 180px; position: relative;">
											<a v-if="modifiable" href="javascript: void(0);" @click="deleteNewImage(file)" style="position: absolute; top: 0px; right: 0px;">X</a>
											<img v-img :src="getImageUrl(file)" class="mgr_15" alt="File Not Found" style="cursor: zoom-in;max-height:130px;max-width:170px;height:auto;width:auto;" />
											<a href="javascript:void(0);" @click="openImagePanel(file)" style="display:block;text-align:center;font-size:12px;">Open in panel</a>
										</td>
										<td v-if="modifiable" class="right_option">
											<button class="btn" @click="uploadFile()">Upload File</button>
											<input type="file" v-show="false" ref="uploadFile" class="file_input_hidden" accept="image/*" @change="uploadFileConfirm()" />
										</td>
									</tr>
								</table>
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div class="view_bottom_bt">
				<a v-if="modifiable && (store_credit.status_code == 'R' || store_credit.status_code == 'C')" href="javascript:;" type="button" class="search_bt mgr_15" @click="save()">Save</a>
				<a v-else-if="modifiable && store_credit.status_code == 'U'" href="javascript:;" type="button" class="search_bt mgr_15" @click="save()">Save Except Amount</a>

				<a v-if="modifiable && mode == 'detail' && user.sc_confirm && store_credit.status_code == 'R'" href="javascript:;" type="button" class="search_bt mgr_15" @click="confirm()">Confirm</a>
				<a v-if="mode === 'detail'" href="javascript:void(0);" type="button" class="search_bt mgr_15" @click="print()">Print</a>

				<a v-if="modifiable && mode == 'detail' && store_credit.status_code == 'C'" href="javascript:;" type="button" class="search_bt mgr_15" @click="payment()">Make A/R Invoice</a>

				<a v-if="modifiable && mode == 'detail' && user.sc_confirm && (store_credit.status_code == 'R' || store_credit.status_code == 'C')" href="javascript:;" type="button" class="search_bt mgr_15" @click="withdraw()">Void</a>

				<a href="javascript:;" type="button" class="gray_bt mgl_15" @click="cancel()">Back</a>
			</div>
		</div>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiIndex, apiSelectStoreCredit, apiInsertStoreCredit, apiUpdateStoreCredit, apiProcessPayment, apiSelectUsedARInvoice } from '@/api/partner/storecredit.js';
import { apiSelectInvoiceItemList } from '@/api/sales/invoice.js';
import CodeSelect from '@/components/common/CodeSelect';
import PartnerSelect from '@/components/common/PartnerSelect';
import SoSelect from '@/components/common/SoSelect';
// import Modal from '@/components/common/Modal';
//import Paging from '@/components/common/Paging';
//import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import { today } from '@/utils/date.js';
import { reportMrtUrl, reportRenderBase64, apiUploadImage, apiDeletFilesByName } from '@/api/util';
import { apiSelectUserList } from '@/api/basicinfo/user.js';
//import { getPossibleStatus } from '@/main.js';

//import ItemClassSelect from '@/components/common/ItemClassSelect';
// import ItemPopup from '@/components/common/ItemPopup';
// import ReceiptPopup from '@/components/common/ReceiptPopup';
// import Modal from '@/components/common/Modal';

// import _ from 'lodash';

// import 'floatthead';
// import { apiGetReportTemplate, companyMrtUrl, objectToFormData, PrintType, Report } from '@/api/util';

export default {
	data: function() {
		return {
			backUri: '/sc/sc_main',

			mode: 'add',

			store_credit: {
				status_code: 'R',
			},

			invoice_item_list: [],

			salesGroups: [],
			arCreditTypeList: [],
			separator: '|',
			org_image_files: [],
			// #3263 : 저장 시 파트너가 실제로 바뀌었는지 비교하는 기준값
			org_partner_code: null,
			// #3263 : 원래 파트너로 되돌아왔을 때 복원할 조회 시점 담당 sales group
			org_sales_group_code: null,
			new_image_files: [],
			delete_files: [],

			wh_staff_list: [],

			float_panel: {
				visible: false,
				src: '',
				x: 300,
				y: 120,
				dragging: false,
				offset_x: 0,
				offset_y: 0,
			},
		};
	},
	computed: {
		// mainCandidateList() {
		// 	return this.prevInvoices.filter(i => i.invoice_type == 'S' && (i.status_code == 'A' || i.status_code == 'P' || i.status_code == 'W'));
		// },
		modifiable() {
			//if (this.store_credit.status_code != 'R') return false;

			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		user: function() {
			return this.$session.get('user');
		},
		isJc() {
			return this.user && this.user.company_id == 'jc';
		},
		// locationCountList: function() {
		// 	let locationCountList = [];

		// 	this.locationList.forEach(value => {
		// 		let obj = { name: value.name, count: 0 };
		// 		locationCountList.push(obj);
		// 	});
		// 	return locationCountList;
		// },
	},

	components: {
		PartnerSelect,
		CodeSelect,
		SoSelect,
	},
	methods: {
		async uploadFile() {
			const elem = this.$refs.uploadFile;
			elem.click();
		},
		async uploadFileConfirm() {
			var file = this.$refs.uploadFile.files[0];
			var { data } = await apiUploadImage(file);
			if (data.result) {
				this.new_image_files.push(data.filename);
				this.$refs.uploadFile.value = null;
				this.$toast.success('File uploaded successfully');
			}
		},
		getImageUrl(file) {
			return process.env.VUE_APP_API_URL + '/file/' + this.user.company_id + '/' + file;
		},
		openImagePanel(file) {
			this.float_panel.src = this.getImageUrl(file);
			this.float_panel.visible = true;
		},
		closePanel() {
			this.float_panel.visible = false;
		},
		startDragPanel(e) {
			this.float_panel.dragging = true;
			this.float_panel.offset_x = e.clientX - this.float_panel.x;
			this.float_panel.offset_y = e.clientY - this.float_panel.y;
			document.addEventListener('mousemove', this.onDragPanel);
			document.addEventListener('mouseup', this.stopDragPanel);
			e.preventDefault();
		},
		onDragPanel(e) {
			if (!this.float_panel.dragging) return;
			let nx = e.clientX - this.float_panel.offset_x;
			let ny = e.clientY - this.float_panel.offset_y;
			this.float_panel.x = Math.max(0, Math.min(nx, window.innerWidth - 80));
			this.float_panel.y = Math.max(0, Math.min(ny, window.innerHeight - 40));
		},
		stopDragPanel() {
			this.float_panel.dragging = false;
			document.removeEventListener('mousemove', this.onDragPanel);
			document.removeEventListener('mouseup', this.stopDragPanel);
		},
		deleteOrgImage(file) {
			let idx = this.org_image_files.findIndex(image => image === file);
			if (idx > -1) this.org_image_files.splice(idx, 1);

			this.delete_files.push(file);

			this.$toast.success('When Save Credit Info<br /> Image Will Be Deleted.');
		},
		deleteNewImage(file) {
			let idx = this.new_image_files.findIndex(image => image === file);
			if (idx > -1) this.new_image_files.splice(idx, 1);

			this.delete_files.push(file);

			this.$toast.success('When Save Credit Info<br /> Image Will Be Deleted.');
		},

		async payment() {
			//console.log(await this.checkUsed());
			if (await this.checkUsed()) return;
			else {
				if (await this.checkUsedInvoice()) return;
				this.$alertify.confirm('Are you sure to make A/R (Credit or Dept) Invoice?', () => {
					this.paymentConfirm();
				});
			}
		},
		async paymentConfirm() {
			var { data } = await apiProcessPayment(this.store_credit);
			if (data.result) {
				this.$toast.success('A/R Invoice made successfully');

				await this.selectStoreCredit();
			} else {
				this.$toast.error(data.msg);
			}
		},
		async setInvoiceFromList(invoice) {
			//console.log(invoice);
			this.store_credit.linked_invoice_no = invoice.invoice_no;
			this.store_credit.linked_invoice_dn = invoice.invoice_dn;
			await this.loadInvoiceItems();
		},
		// JC 전용: 연결된 인보이스의 아이템 내역 조회 (Store Credit 상세 표시용)
		async loadInvoiceItems() {
			if (!this.isJc) return;
			if (!this.store_credit.linked_invoice_no) {
				this.invoice_item_list = [];
				return;
			}
			const { data } = await apiSelectInvoiceItemList({ invoice_no: this.store_credit.linked_invoice_no });
			this.invoice_item_list = data.invoiceItemList || [];
		},
		setPartner(partner) {
			//console.log(partner);
			this.store_credit.partner_code = partner.code;

			// #3263 : PartnerSelect 는 같은 코드를 다시 확정하거나 입력 후 blur 하기만 해도 set-partner 를 emit 한다.
			// 그래서 무조건 덮어쓰면 파트너를 바꾸지 않은 저장에서도 담당 sales group 이 조용히 파트너 기본값으로 바뀐다.
			// 실제로 다른 파트너가 된 경우에만 새 파트너의 기본값을 적용하고, 원래 파트너로 되돌아오면 조회 시점 값을 복원한다.
			if (this.mode == 'add') {
				this.store_credit.sales_group_code = partner.sales_group_code;
			} else if (partner.code != this.org_partner_code) {
				this.store_credit.sales_group_code = partner.sales_group_code;
			} else {
				this.store_credit.sales_group_code = this.org_sales_group_code;
			}
		},

		async selectStoreCredit() {
			const { data } = await apiSelectStoreCredit({
				sc_no: this.store_credit.sc_no,
			});

			this.store_credit = data.store_credit;
			this.org_partner_code = this.store_credit ? this.store_credit.partner_code : null;
			this.org_sales_group_code = this.store_credit ? this.store_credit.sales_group_code : null;
			if (this.store_credit && this.store_credit.image_file_names) this.org_image_files = this.store_credit.image_file_names.split(this.separator);
			else this.org_image_files = [];

			await this.loadInvoiceItems();
		},

		async print() {
			const { data } = await apiSelectStoreCredit({
				sc_no: this.store_credit.sc_no,
			});
			await reportRenderBase64(data, 'StoreCredit', reportMrtUrl('storeCredit'));
		},
		async checkUsedInvoice() {
			const { data } = await apiSelectUsedARInvoice({
				sc_dn: this.store_credit.sc_dn,
			});

			//console.log(data.store_credit);

			if (data.invoice && data.invoice.invoice_no > 0) {
				this.$toast.error('Already Used. Please contact system maintenance team.');
				return true;
			} else return false;
		},
		async checkUsed() {
			const { data } = await apiSelectStoreCredit({
				sc_no: this.store_credit.sc_no,
			});

			//console.log(data.store_credit);

			// #3263 : status_code 'U' 만 보면 status_code 가 'C' 인데 ar_invoice_no 가 붙은 건을 놓친다.
			// AR credit memo 가 이미 있으면 confirm/withdraw/payment 는 어느 상태에서도 막는다.
			if (data.store_credit.ar_invoice_no || data.store_credit.status_code == 'U') {
				this.$toast.error('Already Used');
				return true;
			} else return false;
		},
		checkValidity() {
			if (!this.store_credit.sales_group_code) {
				this.$toast.error('Empty Sales Person');
				return false;
			}

			if (!this.store_credit.partner_code) {
				this.$toast.error('Empty Partner Code');
				return false;
			}

			if (this.user.company_id == 'hairplus' && !this.store_credit.ar_credit_type_code) {
				this.$toast.error('Empty A/R Credit Type');
				return false;
			}

			if (!this.store_credit.amount) {
				this.$toast.error('Empty Amount');
				return false;
			}

			return true;
		},

		async save() {
			// #3263 : 사용 완료 건의 파트너 정정은 막지 않는다. 연결된 AR credit memo 로 함께 옮길 수 있는지는
			// 서버가 판정하고, 옮길 수 없으면 저장 전체가 사유 메시지와 함께 실패한다.
			// 다만 AR 자료까지 같이 움직이는 저장이므로, 그 사실을 알리고 한 번 확인받는다.
			if (this.isArPartnerChange()) {
				this.$alertify.confirm(
					'This Store Credit has already been made into an A/R credit memo. Changing the partner will also move that A/R record to the new partner, so it will disappear from the current partner. Are you sure to continue?',
					() => {
						this.saveConfirmed();
					},
				);
				return;
			}

			await this.saveConfirmed();
		},
		// #3263 : 이미 AR credit memo 가 만들어진 건에서 파트너가 실제로 바뀌었는가.
		isArPartnerChange() {
			return !!this.store_credit.ar_invoice_no && this.store_credit.partner_code != this.org_partner_code;
		},
		async saveConfirmed() {
			if (this.checkValidity()) {
				await this.submit(false);
			}
		},
		async withdraw() {
			if (await this.checkUsed()) return;

			this.$alertify.confirm('Are you sure to make void?', () => {
				this.store_credit.status_code = 'W';
				this.submit(true);
			});
		},
		async confirm() {
			if (await this.checkUsed()) return;

			this.$alertify.confirm('Are you sure to confirm?', () => {
				this.store_credit.status_code = 'C';
				this.submit(true);
			});
		},
		cancel() {
			this.$router.push(this.backUri);
		},
		defineFileNamesForSubmit() {
			let image_file_names = '';
			if (this.org_image_files.length > 0) image_file_names += this.org_image_files.join(this.separator);
			if (this.new_image_files.length > 0) image_file_names += (image_file_names ? this.separator : '') + this.new_image_files.join(this.separator);

			this.store_credit.image_file_names = image_file_names || null;

			this.store_credit.delete_file_names = this.delete_files;
		},
		redefineFileArray() {
			// this.new_image_files.forEach(new_img => {
			// 	this.org_image_files.push(new_img);
			// });

			this.org_image_files = this.org_image_files.concat(this.new_image_files);

			this.new_image_files = [];
			this.delete_files = [];
		},
		async submit(status_changed) {
			this.defineFileNamesForSubmit();

			var response;
			if (this.mode == 'add') {
				response = await apiInsertStoreCredit(this.store_credit);
			} else {
				// #3263 : 서버가 "화면이 본 파트너"와 현재 값을 비교해, 조회 뒤 남이 바꾼 경우의 저장을 거부한다.
				response = await apiUpdateStoreCredit({ ...this.store_credit, org_partner_code: this.org_partner_code }, status_changed);
			}
			var data = response.data;
			if (data.result) {
				this.$toast.success('Saved successfully');
				//console.log(this.backUri);
				if (this.mode == 'add') {
					this.store_credit.sc_no = data.sc_no;
					//this.store_credit.sc_dn = data.sc_dn;
					this.mode = 'detail';
					this.$store.commit('setSubTitle', 'Store Credit -> Detail');
				}

				this.redefineFileArray();
				await this.selectStoreCredit();
			} else {
				this.$toast.error(data.msg);
			}
		},

		async index() {
			const { data } = await apiIndex();

			this.salesGroups = data.salesGroupList;
			this.arCreditTypeList = data.arCreditTypeList;
		},
		async init() {
			await this.index();

			let { data } = await apiSelectUserList({
				active_yn: 'Y',
				user_type: 'whstaff',
				sort_key: 'user_name',
			});

			this.wh_staff_list = data.userList;
			// this.saleStatusCodes = this.$saleStatusCodes;

			// var response;

			if (this.mode == 'detail') {
				await this.selectStoreCredit();
				//console.log(getPossibleStatus(this.invoice.status_code));
				//this.saleStatusCodes = getPossibleStatus(this.invoice.status_code);
			}
		},
	},
	created() {
		if (this.$route.query.backUri) this.backUri = this.$route.query.backUri;
		this.mode = this.$route.params.mode;

		this.$store.commit('setSideIndex', 8);
		this.$store.commit('setSelectedMenu', 'nav_li_sc_main');

		if (this.mode == 'add') {
			this.$store.commit('setSubTitle', 'Store Credit -> Add');
			this.store_credit.request_date = today();
			//this.invoice.so_date = today();
		} else {
			this.$store.commit('setSubTitle', 'Store Credit -> Detail');
			this.store_credit.sc_no = this.$route.query.sc_no;

			if (!this.store_credit.sc_no) {
				//console.log('empty...', this.backUri);
				this.$router.push(this.backUri);
				return;
			}
		}

		this.init();
	},
	mounted() {
		inputSelectOnClick();
	},
	beforeDestroy() {
		if (this.new_image_files.length > 0) apiDeletFilesByName(this.new_image_files);
	},
};
</script>

<style>
td a:hover {
	text-decoration: underline;
	color: #ff0000;
}

.sc-float-panel {
	position: fixed;
	z-index: 9999;
	width: 520px;
	height: 640px;
	min-width: 260px;
	min-height: 220px;
	background: #fff;
	border: 1px solid #888;
	box-shadow: 0 4px 18px rgba(0, 0, 0, 0.35);
	resize: both;
	overflow: hidden;
	display: flex;
	flex-direction: column;
}
.sc-float-header {
	flex: 0 0 auto;
	cursor: move;
	background: #2d3e50;
	color: #fff;
	padding: 6px 10px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	user-select: none;
}
.sc-float-close {
	color: #fff;
	font-weight: bold;
	padding: 0 4px;
}
.sc-float-body {
	flex: 1 1 auto;
	overflow: auto;
	background: #f5f5f5;
	text-align: center;
}
.sc-float-body img {
	width: 100%;
	height: auto;
	display: block;
}
</style>
